module.exports = __webpack_public_path__ + "img/infodump-locked.f639892a.svg";